import { useContext, useEffect, useState } from "react";
import { MdArrowOutward, MdCheckCircle } from "react-icons/md";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { whyChooseUs } from "../siteContent";

export default function HomeBanner3(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <div className="MainBodySection tff-why-section">
      <div className="container">
        <div className="row g-4 align-items-center">
          <div className="col-lg-5">
            <div className="tff-section-kicker">Why Choose Us</div>
            <h2 className="tff-section-title">
              A polished Zanzibar travel experience from arrival to farewell.
              <span className="tff-section-underline"></span>
            </h2>
            <p className="font-light tff-section-lead">
              We combine local expertise, reliable operations, and a personalized service culture to make every journey
              feel intentional, smooth, and worthwhile.
            </p>
          </div>
          <div className="col-lg-7">
            <div className="row g-3">
              {whyChooseUs.map((item) => (
                <div key={item} className="col-md-6">
                  <div className="tff-why-card">
                    <MdCheckCircle size={24} className="text-secondary mb-3" />
                    <p className="font-semi-bold mNoMargin">{item}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="text-lg-end mt-4">
              <button
                className="btn btn-primary btn-rounded btn-padded"
                onClick={() => {
                  appContext.navTo({ item: "contact_us" });
                }}
              >
                Build Your Zanzibar Plan
                <MdArrowOutward size={18} className="ms-2" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
